<script>
import { BRow } from "bootstrap-vue";

export default {
  extends: BRow
};
</script>